import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";

export const TopNavLoader = () => {
  const location = useLocation();

  useEffect(() => {
    NProgress.configure({ showSpinner: false }); // 🔧 Disable spinner
    NProgress.start();

    // stop after a short delay (simulate page load time)
    const timeout = setTimeout(() => {
      NProgress.done();
    }, 300); // optional: control loading feel

    return () => {
      clearTimeout(timeout);
      NProgress.done(); // ensure it stops on unmount
    };
  }, [location.pathname]);

  return null;
};
